import { ChangeDetectorRef, Component, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { ThesaurusEntry } from '@interfaces/thesaurus-entry.interface';
import { TermsService } from '@terms-service/terms.service';
import { EntryService } from 'app/services/entry/entry.service';

@Component({
    selector: 'app-collapsing-qualifier-notes',
    templateUrl: './collapsing-qualifier-notes.component.html',
    styleUrls: ['./collapsing-qualifier-notes.component.scss'],
    standalone: false
})
export class CollapsingQualifierNotesComponent {
  @Input() collapseQualifierId: string = "";
  @Input() entry!: ThesaurusEntry;
  @Input() thesaurusId: string = "";
  qualifierTerm: string = "qualifier";
  @Output() collapseToggled = new EventEmitter<string>();
  isExpanded = false;
  expandedIndex: number | null = null;
  showClass: string = "show";
  collapsingClass: string = 'collapsing';
  collapseClass: string = 'collapse';
  qualifierIdString: string = "";

  constructor(
    public termsService: TermsService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private entryService: EntryService
  ) { }

  closeBtn(elementId: string) {
    this.collapseToggled.emit(elementId);
  }

  onQualifierCheckboxChange(name: string, event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    this.termsService.updateList(name, this.qualifierTerm, isChecked, this.entry!.notUnique, this.entry!.paths, this.entry);
  }

  //Toggle display of qualifier description "collapse" component, in addition to toggling the display of the up/down chevron icons.
   toggleCollapse(collapseId: string, event: Event, index: number): void {
    event.preventDefault();
    const collapseElement = document.getElementById(collapseId);
    const triggerElement = document.querySelector(`[aria-controls="${collapseId}"]`);
    const allCollapseElements = document.querySelectorAll('.show');

    if (collapseElement && triggerElement) {
      //Toggle chevron icons
      const downChevron = document.getElementById(`chevron-double-down-${this.getQualifierId()}-${index}`);
      const upChevron = document.getElementById(`chevron-double-up-${this.getQualifierId()}-${index}`);

      //Toggle dropdown
      const isCollapsing = collapseElement.classList.contains(this.showClass);

      if (isCollapsing) {
        this.renderer.removeClass(collapseElement, this.showClass);
        this.renderer.addClass(collapseElement, this.collapsingClass);
        setTimeout(() => {
          this.renderer.removeClass(collapseElement, this.collapsingClass);
          this.renderer.addClass(collapseElement, this.collapseClass);
          this.renderer.setAttribute(triggerElement, 'aria-expanded', 'false');
          this.renderer.removeClass(downChevron, "hidden");
          this.renderer.addClass(upChevron, "hidden");
        }, 10);
      } else {
        this.renderer.removeClass(collapseElement, this.collapseClass);
        this.renderer.addClass(collapseElement, this.collapsingClass);
        this.renderer.setAttribute(triggerElement, 'aria-expanded', 'true');
        this.renderer.removeClass(upChevron, "hidden");
          this.renderer.addClass(downChevron, "hidden");
        setTimeout(() => {
          this.renderer.removeClass(collapseElement, this.collapsingClass);
          this.renderer.addClass(collapseElement, this.showClass);
        }, 10);
      }
    }
  }

  getQualifierId(): string {
    if (!this.qualifierIdString) {
      const match = this.collapseQualifierId.match(/^entry-qualifier-notes(.+)/);
      this.qualifierIdString = match?.[1] ?? '';
    }
    return this.qualifierIdString;
  }
}